<template>
  <div class="PacientesForm">
    <v-card
      :loading="cargando"
      :disabled="cargando"
      outlined
    >
      <v-card-title v-text="(paciente.id ? 'Editar' : 'Registrar') + ' paciente'" />
      <v-card-text>
        <div id="infoGeneral">
          <v-card-subtitle v-text="'Información general'" />
          <v-row>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                v-model="paciente.nombre_pac"
                :error-messages="errors.nombre_pac"
                label="Nombre*"
                filled
                @blur="_checkIfExists"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                v-model="paciente.ape_pat_pac"
                :error-messages="errors.ape_pat_pac"
                label="Apellido paterno*"
                filled
                @blur="_checkIfExists"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                v-model="paciente.ape_mat_pac"
                :error-messages="errors.ape_mat_pac"
                label="Apellido materno*"
                filled
                @blur="_checkIfExists"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <SelectSexo
                label="Sexo*"
                v-model="paciente.sexo_pac"
                :error="errors.sexo_pac"
                @change="_checkIfExists"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                :error-messages="errors.fecha_nac_pac"
                filled
                hint="día-mes-año"
                label="Fecha de nacimiento*"
                placeholder="DD-MM-YYYY"
                persistent-hint
                prepend-inner-icon="today"
                v-mask="'##-##-####'"
                v-model="paciente.fecha_nac_pac"
                @blur="_checkIfExists"
              />
              <!-- <v-text-field
                  v-model="paciente.fecha_nac_pac"
                  label="Fecha de nacimiento*"
                  placeholder="YYYY-MM-DD"
                  v-mask="'####-##-##'"
                  hint="Año-mes-dúa"
                  prepend-inner-icon="today"
                  filled
                  :error="errors.fecha_nac_pac"
                  @blur="_checkIfExists"
                /> -->
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                v-model="paciente.curp_pac"
                label="CURP"
                maxlength="18"
                filled
                v-mask="'AAAA######AAAAAA##'"
              />

            </v-col>
          </v-row>
        </div>
        <div id="infoDemografica">
          <v-card-subtitle v-text="'Información demográfica'" />
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <AutocompleteDataEstados
                label="Estado*"
                isSelect
                v-model="paciente.id_edo_pac"
                :error="errors.id_edo_pac"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <AutocompleteDataMunicipios
                label="Municipio*"
                isSelect
                :estado="paciente.id_edo_pac"
                v-model="paciente.id_mpio_pac"
                :error="errors.id_mpio_pac"
              />
            </v-col>

            <v-col
              cols="12"
              sm="8"
              md="3"
              lg="4"
            >
              <v-text-field
                v-model="paciente.calle_pac"
                :error-messages="errors.calle_pac"
                label="Calle*"
                filled
              />
            </v-col>
            <v-col
              cols="6"
              sm="2"
              md="2"
              lg="1"
            >
              <v-text-field
                v-model="paciente.num_ext_pac"
                :error-messages="errors.num_ext_pac"
                label="# ext*"
                filled
              />
            </v-col>
            <v-col
              cols="6"
              sm="2"
              md="2"
              lg="1"
            >
              <v-text-field
                v-model="paciente.num_int_pac"
                :error-messages="errors.num_int_pac"
                label="# int"
                filled
              />
            </v-col>
            <v-col
              cols="6"
              sm="8"
              md="3"
              lg="3"
            >
              <v-text-field
                v-model="paciente.colonia_pac"
                :error-messages="errors.colonia_pac"
                label="Colonia*"
                filled
              />
            </v-col>
            <v-col
              cols="6"
              sm="4"
              md="2"
              lg="2"
            >
              <v-text-field
                v-model="paciente.cp_pac"
                :error-messages="errors.cp_pac"
                label="C.P."
                filled
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                v-model="paciente.lugar_nac_pac"
                label="Lugar de nacimiento"
                filled
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-select
                v-model="paciente.ser_medico_pac"
                :error-messages="errors.ser_medico_pac"
                label="Servicio médico"
                :items="optionsSerMed"
                filled
              />
            </v-col>
          </v-row>
        </div>
        <div class="infoContacto">
          <v-card-subtitle v-text="'Información de contacto'" />
          <v-row>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                v-model="paciente.cel_pac"
                label="Teléfono móvil*"
                maxlength="14"
                type="tel"
                filled
                prepend-inner-icon="smartphone"
                v-mask="'### ###-####'"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
            >
              <v-text-field
                v-model="paciente.email_pac"
                label="Correo electrónico"
                type="email"
                filled
                prepend-inner-icon="alternate_email"
              />
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          to="/"
          v-text="'Cancelar'"
        />
        <v-btn
          color="primary"
          :loading="cargando"
          @click="_preSavePac"
        >
          {{paciente.id ? 'Actualizar' : 'Guardar'}}
        </v-btn>
      </v-card-actions>
    </v-card>

    <PacientesAcciones
      v-model="showDialogAcciones"
      :idPac="paciente.id"
      :paciente="paciente"
      @msg="$emit('msg',$event)"
      @httpError="$emit('httpError',$event)"
    />

    <v-dialog
      v-model="showDialogExiste"
      max-width="500"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title v-html="'Se encontraron pacientes con los mismos datos'" />
        <v-card-subtitle v-html="'¿Alguno de los resultados es quien intentas registrar?'" />
        <v-list-item-group>
          <div
            v-for="(item,i) in pacientes"
            :key="i"
          >
            <v-divider />
            <v-list-item @click="paciente = item; showDialogAcciones = true; showDialogExiste=false;">
              <v-list-item-content>
                <v-list-item-title v-text="`${item.nombre_pac} ${item.ape_pat_pac} ${item.ape_mat_pac}`" />
                <v-list-item-subtitle v-text="`${item.fecha_nac_pac}, Domicilio: ${item.calle_pac}`" />
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon v-text="'keyboard_arrow_right'" />
              </v-list-item-icon>
            </v-list-item>
          </div>
        </v-list-item-group>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            v-text="'Cancelar'"
            @click="showDialogExiste=false"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import standard from "@/mixins/standard.js";
import pacientesCRUD from "@/mixins/pacientesCRUD.js";
import getPacientes from "@/mixins/getPacientes.js";
export default {
  name: "PacientesForm",
  mixins: [standard, pacientesCRUD, getPacientes],
  data() {
    return {
      showDialogAcciones: false,
      showDialogExiste: false,
    };
  },
  components: {
    AutocompleteDataEstados: () =>
      import("@/components/forms/autocompletes/AutocompleteDataEstados.vue"),
    AutocompleteDataMunicipios: () =>
      import("@/components/forms/autocompletes/AutocompleteDataMunicipios.vue"),
    DatePicker: () => import("@/components/forms/pickers/DatePicker.vue"),
    SelectSexo: () => import("@/components/forms/selects/SelectSexo.vue"),
    PacientesAcciones: () =>
      import("@/components/pacientes/PacientesAcciones.vue"),
  },
  methods: {
    _checkIfExists() {
      if (
        !this.paciente.id &&
        this.paciente.nombre_pac &&
        (this.paciente.ape_pat_pac || this.paciente.ape_mat_pac)
      ) {
        this._searchPac(this.paciente);
      }
    },
    _pacsHasData() {
      if (this.pacientes.length >= 1) this.showDialogExiste = true;
    },
    _shouldGetPac() {
      if (this.$route.params.idPac) {
        this._getPac(this.$route.params.idPac);
      }
    },
  },
  created() {
    this._shouldGetPac();
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler: "_shouldGetPac",
    },
    pacientes: {
      deep: true,
      immediate: true,
      handler: "_pacsHasData",
    },
    showDialogExiste(a) {
      if (!a) {
        this.pacientes = [];
      }
    },
  },
};
</script>
